import { GEOSPATIAL_LAT_LON_DELIMITER } from "Common/componentUtils/constants";
import { withTooltip } from "Components/withPopover";
import React, { memo, useCallback, useLayoutEffect, useState } from "react";
import TextWidget from "../textWidget";
import locale from "./geospatialWidget.locale";
const formatErrorValidationError = { message: locale.FORMAT_ERROR_MESSAGE };
const geospatialStringRegexp = new RegExp(`^-?(((\\d|([0-8]\\d))((\\.|,)\\d*)?)|90)${GEOSPATIAL_LAT_LON_DELIMITER}-?(((\\d|(\\d\\d)|(1[0-7]\\d))((\\.|,)\\d*)?)|180)$`);
const GeospatialTextWidget = withTooltip(TextWidget);
function GeospatialWidget({ className, value, fieldName, onChange, validationError, validationMessagePosition, validationStatus, validationMessageMode, ...other }) {
    const [innerValue, setInnerValue] = useState(value);
    const [valid, setValid] = useState(true);
    useLayoutEffect(() => {
        setInnerValue(value);
    }, [value]);
    const handleChange = useCallback((newVal) => {
        const isValid = geospatialStringRegexp.test(newVal);
        setValid(isValid);
        setInnerValue(newVal);
        isValid && onChange && onChange(newVal, fieldName);
    }, [onChange, fieldName]);
    return (React.createElement(GeospatialTextWidget, { className: className, value: innerValue, popoverContent: locale.TOOLTIP, popoverClassName: "dark-popover font-small pre-wrap", fieldName: fieldName, onChange: handleChange, ...other, validationMessageMode: !valid ? "always" : validationMessageMode, validationMessagePosition: !valid ? "bottom" : validationMessagePosition, validationError: !valid ? formatErrorValidationError : validationError, validationStatus: !valid ? "invalid" : validationStatus || "valid" }));
}
export default memo(GeospatialWidget);
